<label class="border border-secondary rounded-lg cursor-pointer block hover:bg-gray-50 p-3 px-5 transition-colors">
  <mat-checkbox
    class="ui-checkbox-wrapped-checkbox w-full"
    [ngModel]="checked()"
    [disabled]="disabled()"
    (ngModelChange)="onCheckboxChange($event)">
    <ng-content></ng-content>
  </mat-checkbox>
</label>
